import { createSelector } from 'reselect';
import { getProductDetails } from '../products/selectors';

export const getProductTypesData = (state) => state.productTypes;
export const getProductTypesListingData = (state) => state.productTypes.listing;

export const isLoadingProductTypesList = (state) => getProductTypesListingData(state).isLoading;

export const areProductTypesListLoaded = (state) => getProductTypesListingData(state).areProductTypesLoaded;

export const getProductTypesList = (state) => getProductTypesListingData(state).productTypesList.map(type => ({
    ...type,
    photo: type.products.length 
        ? (getProductDetails(state, {productId: type.products[Math.floor(Math.random()*type.products.length)]}) || {}).photo
        : undefined
}));

export const getProductTypeDetails = (state, { productTypeId }) =>
    getProductTypesList(state).reduce((acc, cur) => ({
        ...acc, 
        [cur.id]: cur
    }), {})[productTypeId];


export const getProductTypeDetailsWithProducts = (state, {productTypeId}) => {
    const type = getProductTypeDetails(state, {productTypeId});

    return type ? ({
        ...type,
        products: type.products.map(productId => getProductDetails(state, {productId}))
    }) : undefined;
};